import React, { useEffect, useState } from "react";



const Story = ({
  language,
  storyContentEN,
  storyContentAR,
  storyTitle,
  storyContent,
  buttonText,
  directionClass,
  image,
  bodyClass,
  buttonNavigation
}) => {


  const [windowSize, setWindowSize] = useState(window.innerWidth > 991);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth > 991);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="container story-container">
      <div className="row">
        <div
          className={`col-md-6 col-12 ${
            language === "ar" && windowSize ? "order-1" : ""
          }`}
        >
          <img src={image} alt="story" />
        </div>
        <div className={`col-md-6 col-12 content-body ${directionClass} ${bodyClass}`}>
          <div className="line-top"></div>
          <h2 className="story-title">{storyTitle}</h2>
          {storyContent.map((text, index) =>
            index === 1 ? (
              <p key={index} className="story-quote">
                {text}
              </p>
            ) : (
              <p key={index}>{text}</p>
            )
          )}
          <button className="story-btn" onClick={buttonNavigation}>
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Story;
